import * as React from "react";
import { useLocale } from "@/contexts/useLocale";
import {
  formatDateWithLocale,
  formatTimeWithLocale,
  formatDateTimeWithLocale,
  formatDateShortWithLocale,
  formatDayName,
  formatDayMonthWithLocale,
  formatDetailedDateTimeWithLocale,
  formatMonthYearWithLocale,
  toRelativeDate,
} from "@/helpers/dates";

export const useDateFormatter = () => {
  const { dateFormat, timeFormat } = useLocale();

  return React.useMemo(
    () => ({
      formatDate: (date: Date | string | number) => formatDateWithLocale(date, dateFormat),
      formatTime: (date: Date | string | number, includeSeconds = false) =>
        formatTimeWithLocale(date, timeFormat, includeSeconds),
      formatDateTime: (date: Date | string | number, includeSeconds = false) =>
        formatDateTimeWithLocale(date, dateFormat, timeFormat, includeSeconds),
      formatDateShort: (date: Date | string | number) => formatDateShortWithLocale(date, dateFormat),
      formatDayName: (date: Date | string | number) => formatDayName(date),
      formatDayMonth: (date: Date | string | number) => formatDayMonthWithLocale(date, dateFormat),
      formatDetailedDateTime: (date: Date | string | number) =>
        formatDetailedDateTimeWithLocale(date, dateFormat, timeFormat),
      formatMonthYear: (date: Date | string | number) => formatMonthYearWithLocale(date, dateFormat),
      formatRelative: (date: string | null) => toRelativeDate(date),
    }),
    [dateFormat, timeFormat],
  );
};
